export const en = {
    all_day: '24 hours',
    friday: 'Fri',
    monday: 'Mon',
    saturday: 'Sat',
    sunday: 'Sun',
    thursday: 'Thu',
    tuesday: 'Tue',
    wednesday: 'Wed',
    weekends: 'weekends',
    working_days: 'workdays'
};
